<template>
  <div class="order-wrap">
    <div class="order-header">
      <p class="b-order-list">
        {{ orderType === 'b' ? $t('components_order_order_list_489') : $t('components_order_order_list_490')}}
      </p>
      <div v-if="orderType === 'b'" class="tools">
        <div class="tools-button pointer" @click="openOrderCourse">
          <span>{{$t('components_order_order_list_491')}}</span>
          <div
            v-if="showBubble"
            class="bubble"
            @click.stop="showBubble = false"
          >{{$t('components_order_order_list_492')}}</div>
        </div>
      </div>
    </div>
    <div class="screen-btn-list">
      <button
        v-for="s in statusList"
        :key="s.type"
        class="screen-btn"
        @click="filterOrderQuery(s.value)"
        :class="orderQueryStatus === s.value ? 'select-screen' : null"
      >{{ s.name }}</button>
    </div>
    <div
      v-if="!orderListArr.length && isFinish && !isLoading"
      class="empty-list"
    >
      <span>{{$t('components_order_order_list_493')}}</span>
    </div>
    <div v-else-if="orderListArr.length" class="order-list">
      <orderCard
        v-for="(item, index) in orderListArr"
        :ref="'orderCardRef' + item.orderNo"
        :key="index"
        :index="index"
        :type="orderType"
        :orderInfo="item"
        @detail="orderDetail"
        @getOrderList="getOrderList"
      />
    </div>
    <div v-if="isLoading" class="loading-line">
      <p>
        <i class="el-icon-loading" />
      </p>
    </div>
    <div
      v-else-if="!isFinish && !isLoading && orderListArr.length"
      class="check-more"
      @click="getOrderList"
    >{{$t('components_order_order_list_494')}}</div>
    <el-dialog
      :visible.sync="orderDetailVisible"
      width="418px"
      append-to-body
      :title="$t('components_order_order_list_495')"
      :orderNo="currentOrderNo"
    >
      <bOrderDetail
        v-if="orderDetailVisible"
        :userType="orderType"
        :orderNo="currentOrderNo"
        @cancleOrder="handleEvent('cancleOrder', $event)"
        @controversyOrder="handleEvent('controversyOrder', $event)"
        @completeOrder="handleEvent('completeOrder', $event)"
        @writeReview="handleEvent('writeReview', $event)"
        @refoundDetail="handleEvent('refoundDetail', $event)"
        @refoundOrder="handleEvent('refoundOrder', $event)"
        @acceptOrder="handleEvent('acceptOrder', $event)"
      />
    </el-dialog>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import orderCard from '@/components/Order/order-card.vue';
import bOrderDetail from '@/components/Order/b-order-detail.vue';
import { mapGetters } from 'vuex';
import { getInviterUuid } from '@/api'

export default {
  props: {
    orderType: {
      type: String,
      default: 'c',
    },
  },
  components: {
    orderCard,
    bOrderDetail,
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data() {
    const showBubble = this.getBubble();
    return {
      statusList: [
        {
          state: 'null',
          value: null,
          name: i18n.t('components_order_order_list_496')
        },
        {
          state: 'PlayerActive',
          value: 'PlayerActive',
          name: i18n.t('components_order_order_list_497')
        },
        {
          state: 'History',
          value: 'History',
          name: i18n.t('components_order_order_list_498')
        },
      ],
      showBubble,
      orderListArr: [],
      isLoading: false,
      orderDetailVisible: false,
      offset: 10,
      currentOrderNo: '',
      currentType: '',
      orderQueryStatus: null,
      isFinish: false,
      giftInfo: {},
      selectedGiftCount: 0,
    };
  },
  created() {
    if (this.$route.query.reorder) {
      this.reportInviterInfo()
      
      // window.gtag('reorder_click', 'reorder', this.userInfo.uuid);
      this.$router.replace({
        path: this.$router.path,
      });
    }
    if (this.$route.query.dragonBoat) {
      // window.gtag('goorder_paysuccess', 'DragonBoatFestival', this.userInfo.uuid);
      this.$router.replace({
        path: this.$router.path,
      });
    }
    this.getOrderList();
  },
  mounted() {
    if (this.showBubble) {
      const HAS_SHOWED_ORDER_CROUSE = 'HAS_SHOWED_ORDER_CROUSE';
      window.localStorage.setItem(HAS_SHOWED_ORDER_CROUSE, true);
    }
  },
  methods: {
    reportInviterInfo() {
      try {
        let uuid = this.$store.state.app.userInfo.uuid
        getInviterUuid({uuid:uuid}).then(({data})=>{
          this.$adjust('web_order_paid', {
            inviterUuid: data && data.invitedUuid ? data.invitedUuid : 0,
            current_uuid: uuid,
            methods: 'lanxin'
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    getBubble() {
      const HAS_SHOWED_ORDER_CROUSE = 'HAS_SHOWED_ORDER_CROUSE';
      if (window.localStorage.getItem(HAS_SHOWED_ORDER_CROUSE)) {
        return false;
      } else {
        return true;
      }
    },
    openOrderCourse() {
      this.$router.push({
        path: '/order-score',
      });
    },
    dialogClosed() {
      this.orderDetailVisible = false;
    },
    orderDetail(orderNo, index) {
      this.currentOrderNo = orderNo;
      this.currentType = index;
      console.warn(index);
      this.orderDetailVisible = true;
    },
    getOrderList() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const lastItemUuid = this.orderListArr.length
        ? this.orderListArr[this.orderListArr.length - 1].orderNo
        : null;
      this.$http.get(this.orderType === 'b' ? 'order/list/master' : 'order/list', {
        lastItemUuid,
        offset: this.offset,
        orderQueryStatus: this.orderQueryStatus,
      }).then(({ data }) => {
        if (data && Array.isArray(data.pageContent)) {
          if (lastItemUuid) {
            // 非第一页数据
            this.orderListArr = this.orderListArr.concat(data.pageContent);
          } else {
            // 第一页数据
            this.orderListArr = data.pageContent;
          }

          this.isFinish = data.pageContent.length !== this.offset;
        } else {
          this.isFinish = true;
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
    },
    filterOrderQuery(query) {
      if (this.isLoading) {
        return;
      }
      this.orderQueryStatus = query;
      this.orderListArr = [];
      this.getOrderList();
    },
    /**
     * @description: 调起ordercard中调方法（历史迁移问题，待后续重构）
     */
    handleEvent(methodName, orderId) {
      if (typeof orderId === 'object') {
        orderId = orderId.orderNo;
      }
      this.$refs['orderCardRef' + orderId][0][methodName](orderId);
      this.$nextTick(() => {
        this.dialogClosed();
      });
    },
  },
};
</script>
<style lang="scss">
.tools {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.tools-button {
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  position: relative;
  .bubble {
    position: absolute;
    top: 100%;
    right: 0;
    transform: translateY(6px);
    padding: 6px 12px;
    border-radius: 30px;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    background: #ff891e;
    white-space: nowrap;
    &::before {
      content: '';
      width: 0;
      height: 0;
      border-bottom: 7px solid #ff891e;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      position: absolute;
      bottom: 100%;
      right: 18px;
    }
  }
}
.order-wrap > .el-dialog__wrapper {
  .comment-gift-dialog {
    & /deep/ .el-dialog__header {
      padding: 0 !important;
      border: none !important;
    }
    & /deep/ .el-dialog__body {
      padding: 0 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.order-wrap {
  font-style: normal;
  width: 100%;
  color: #999999;
  height: 100%;
  padding: 24px 0;
  box-sizing: border-box;
  .order-header {
    width: 100%;
    text-align: left;
    display: flex;
    margin-bottom: 30px;
    .b-order-list {
      cursor: pointer;
      margin: 0 20px 0 0;
      font-weight: 500;
      font-size: 22px;
      color: $color-gray-1;
    }
  }
  .screen-btn-list {
    width: 100%;
    height: 32px;
    display: flex;
    margin-bottom: 24px;
    justify-content: flex-start;
    border-bottom: 1px solid $color-split;
    .screen-btn {
      color: $color-gray-3;
      margin-right: 24px;
      padding: 0 4px;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      @include flex;
    }
    .select-screen {
      color: $color-link;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background: $color-link;
      }
    }
  }
  .order-msg {
    color: #666666;
    width: 100%;
    height: 42px;
    border-top: 1px solid #ffa040;
    border-bottom: 1px solid #ffa040;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    .order-msg-1 {
      width: 259px;
    }
    .order-msg-2 {
      width: 100px;
    }
    .order-msg-3 {
      width: 86px;
    }
    .order-msg-4 {
      width: 180px;
    }
    .order-msg-5 {
      width: 146px;
    }
    .order-msg-6 {
      width: 149px;
      border: none;
    }
    p {
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      border-right: 1px solid #ffa040;
      height: 25px;
      line-height: 25px;
      margin: 0;
    }
  }
  .empty-list {
    @include flex();
    width: 100%;
    height: 500px;
    text-align: center;
  }
  .order-list {
    width: 100%;
    // min-height: 300px;
  }
  .check-more {
    margin: 30px auto 0;
    cursor: pointer;
    border: 1px solid #dddddd;
    width: 160px;
    height: 40px;
    border-radius: 3px;
    color: #666666;
    text-align: center;
    line-height: 40px;
  }
  .loading-line {
    height: 40px;
    margin: 30px auto 0;

    p {
      @include flex();
      height: 40px;
    }

    i {
      font-size: 1.6em;
    }
  }
}
</style>